import { DrawerFooter } from '@chakra-ui/react';
import { useTheme } from '@emotion/react';

import { Button } from 'uiToolkitV1/Button';

const Footer = ({ onClose, onSubmit, disableSubmit, isLoading }) => {
  const theme = useTheme();

  return (
    <DrawerFooter borderTopWidth="1px" h="72px" backgroundColor={theme.colors.neutral.F5F7F9}>
      <Button variant="outlined" mr={4} onClick={onClose}>
        Cancel
      </Button>
      <Button variant="filled" colorScheme="blue" onClick={onSubmit} disabled={disableSubmit || isLoading}>
        Save
      </Button>
    </DrawerFooter>
  );
};

export default Footer;
